import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ButtonContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
`;

export const Title = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #1b203a;
  white-space: nowrap;

  &.description {
    font-size: 14px;
    font-weight: 400;
    color: #474d66;
  }
`;

export const Button = styled.button`
  display: flex;
  border: 0;
  background-color: transparent;
`;

export const ButtonDiv = styled.button`
  display: flex;
  padding: 10px 16px 10px 16px;
  background-color: transparent;
  color: #1371fe;
  border-radius: 8px;
  border: 0;
  font-size: 14px;
  font-weight: 500;
  align-items: center;

  transition: 0.2s;

  :hover {
    background-color: #f6f8ff;
  }
`;

interface IDivider {
  width?: string;
  height?: string;
}

export const Divider = styled.div<IDivider>`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  justify-content: flex-start;
  gap: 16px;
`;

export const Span = styled.span`
  margin-right: 10px;
  padding-top: 3px;
`;

export const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;

  ::-webkit-scrollbar {
    width: 24px;
    height: 18px;
  }
  ::-webkit-scrollbar-thumb {
    height: 6px;
    border: 8px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 12px;
    background-color: rgba(0, 0, 0, 0.15);
  }
  ::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }
  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }
`;

interface isActiveProps {
  isActive?: boolean;
  isDisabled?: boolean;
  limitOfLines?: number;
}

export const LabelText = styled.div<isActiveProps>`
  display: flex;
  /* white-space: nowrap; */
  font-weight: 500;
  font-size: 14px;
  color: ${({ isActive }) => (isActive ? '#1B203A' : '#696F8C')};
  opacity: ${({ isDisabled }) => (isDisabled ? '0.3' : 'unset')};

  &.help {
    font-size: 14px;
    font-weight: 500;
    color: #474d66;
    margin-left: 8px;
  }

  &.tabble-header {
    font-size: 12px;
    font-weight: 400;
    color: #8f95b2;
  }

  &.tabble-row {
    font-size: 14px;
    font-weight: 400;
    color: #474d66;
  }

  ${({ limitOfLines }) =>
    !!limitOfLines &&
    css`
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: ${limitOfLines}; /* number of lines to show */
      line-clamp: ${limitOfLines};
      -webkit-box-orient: vertical;
    `};
`;

export const TableHeader = styled.div`
  display: grid;
  grid-template-columns: 3fr 1fr 2fr 1.2fr 30px;
  padding: 0 16px 9px 16px;
  gap: 50px;
  align-items: center;

  border-bottom: 1px solid #e6e8f0;
`;

export const TableHeaderManufacturer = styled.div`
  display: grid;
  grid-template-columns: 3fr 2fr 1.2fr 30px;
  padding: 0 16px 9px 16px;
  gap: 50px;
  align-items: center;

  border-bottom: 1px solid #e6e8f0;
`;
